import React from "react";
import privilegeDiscount from "../../../assets/images/privilege-discount-yellow.svg";
import privilegeGift from "../../../assets/images/privilege-gift-yellow.svg";
import privilegeTicket from "../../../assets/images/privilege-ticket-yellow.svg";
import privilegeWheel from "../../../assets/images/privilege-wheel-yellow.svg";

export const Privilages = () => {
  return (
    <div className="privileges row mt-4 ml-0 ml-lg-3">
      <div className="col-12 col-md-5 p-0">
        <div className="privilege-wrapper">
          <img className="icon" src={privilegeTicket} alt="ticket" />
          <div className="privilege-info">
            <span className="title">Öncelikli maç bileti</span>
            <span className="text">Maç biletini herkesten önce al!</span>
          </div>
        </div>
      </div>
      <div className="col-12 col-md-7 p-0">
        <div className="privilege-wrapper">
          <img className="icon" src={privilegeGift} alt="gift" />
          <div className="privilege-info">
            <span className="title">Hediye 4.000 FreeByte</span>
            <span className="text">Her ay hediye 4.000 FreeByte kazan!</span>
          </div>
        </div>
      </div>
      <div className="col-12 col-md-5 p-0">
        <div className="privilege-wrapper">
          <img className="icon" src={privilegeDiscount} alt="discount" />
          <div className="privilege-info">
            <span className="title">Fenerium’da %10 indirim</span>
            <span className="text">Fenerium ürünlerini %10 indirimli al!</span>
          </div>
        </div>
      </div>
      <div className="col-12 col-md-7 p-0">
        <div className="privilege-wrapper">
          <img className="icon" src={privilegeWheel} alt="wheel" />
          <div className="privilege-info">
            <span className="title">Çark-ı Fener hakkı</span>
            <span className="text">
              Loca keyfi, imzalı forma ve birçok sürpriz hediye kazan!
            </span>
          </div>
        </div>
      </div>
      <p className="end-note d-block d-md-none">VE ÇOK DAHA FAZLASI...</p>
      <p className="end-note d-none d-md-block">Ve çok daha fazlası</p>
    </div>
  );
};
